export const routeNames = {
  root: '/',
  home: 'home',
  auth: 'auth',
  login: 'auth/login',
};
